import React, { useEffect } from 'react';
import CalSyncDialog from '../../../sync-flow-v2/components/CalSyncDialog';
import { Text } from '@ps-design-system/components/Text';
import useCalendarStore from '../../../store/calendar/useCalendarStore';
import { NavSteps } from '../../../sync-flow-v2/hooks/useSyncFlowNav';
import { SyncStatus } from '../../util/syncStatus';
import LastUpdated from '../LastUpdated';
import MorePopover from '../MorePopover';
import ConnectCalCTAStrings from './strings';
import { Subject } from 'rxjs';
import { toast } from '@ps-design-system/components/Toast';

export const ResyncErrorSubject$ = new Subject();

const ConnectCalendarCTA = () => {
  const { fetchSyncData } = useCalendarStore();
  const syncStatus = useCalendarStore(state => state.syncStatus);
  const selectedSpaceId = useCalendarStore(state => state.selectedSpaceId);

  useEffect(() => {
    const subscription = ResyncErrorSubject$.subscribe(() => {
      toast({
        title: '',
        description: ConnectCalCTAStrings.resyncError,
        variant: 'destructive',
        duration: 5000
      });
    });
    return () => subscription.unsubscribe();
  }, []);

  const {
    calendar_name,
    profile_name
  } = useCalendarStore(state => state.syncedCalendarData || {});

  useEffect(() => {
    if (selectedSpaceId) {
      fetchSyncData();
    }
  }, [selectedSpaceId]);

  if (!syncStatus) {
    return null;
  }

  const getTitle = () => {
    if (SyncStatus.CONNECTED === syncStatus
      || SyncStatus.SYNCING === syncStatus
      || SyncStatus.SYNC_ERROR === syncStatus
    ) {
      return ConnectCalCTAStrings.titleSynced;
    }

    if (SyncStatus.AUTHORIZED === syncStatus) {
      return ConnectCalCTAStrings.titleCompleteSync;
    }

    return ConnectCalCTAStrings.titleConnect;
  };

  const renderBody = () => {
    if (SyncStatus.NOT_CONNECTED === syncStatus) {
      return (
        <Text typeface="body-2" className="ConnectCalendarCTA_not-connected-desc">
          {ConnectCalCTAStrings.bodyConnect}
        </Text>
      );
    }

    if (SyncStatus.AUTHORIZED === syncStatus) {
      return (
        <Text typeface="body-2" className="ConnectCalendarCTA_not-connected-desc">
          {ConnectCalCTAStrings.bodyCompleteSync}
        </Text>
      );
    }

    return (
      <div>
        <div className="ConnectCalendarCTA_name-more-container">
          <Text typeface="body-2" className="ConnectCalendarCTA_calendar-name">
            {calendar_name || profile_name || ''}
          </Text>
          <MorePopover/>
        </div>
        <LastUpdated/>
      </div>
    );
  };

  return (
    <div className="ConnectCalendarCTA">
      <Text typeface="body-2-m">
        {getTitle()}
      </Text>
      {renderBody()}
      {(SyncStatus.NOT_CONNECTED === syncStatus || SyncStatus.AUTHORIZED === syncStatus) &&
        <CalSyncDialog stepOverride={SyncStatus.AUTHORIZED === syncStatus ? NavSteps.SELECT_CALENDAR : null}/>
      }
    </div>
  );
};

export default ConnectCalendarCTA;
